/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import checkout from "./form";

const {
  formField: {
    name,
      seat_cost,
      late_seat_cost,
      seats
  },
} = checkout;

const initialValues = {
  [name.name]: "",
  [seat_cost.name]: "",
  [late_seat_cost.name]: "",
  [seats.name]: [],
};

export default initialValues;
